<mat-card class="patient-documents-card">
  <mat-card-header style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-bottom: 16px;
  box-sizing: border-box;
  ">
    <mat-card-title>Patient Documents</mat-card-title>
    <button mat-flat-button color="primary" (click)="showUploadArea = !showUploadArea">
      <mat-icon>{{ showUploadArea ? 'close' : 'upload_file' }}</mat-icon>
      {{ showUploadArea ? 'Cancel' : 'Upload Document' }}
    </button>
  </mat-card-header>

  <mat-card-content>
    @if(showUploadArea) {
      <div class="upload-container" style="background: #f5f5f5; padding: 20px; border-radius: 8px; margin-bottom: 20px;">
        <app-upload-ui 
          allowedFilesCategoryLabel="Document" 
          uploadFieldName="Patient Document"
          [maxFiles]="5"
          (filesChanged)="onFilesUploaded($event)">
        </app-upload-ui>
      </div>
    }

    @if(loading) {
      <div style="display: flex; justify-content: center; padding: 40px;">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      @if(documents.length === 0) {
        <div class="empty-state" style="text-align: center; padding: 40px; color: #777;">
          <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 10px; opacity: 0.5;">description</mat-icon>
          <h3>No documents found</h3>
          <p>Click "Upload Document" to add files for this patient.</p>
        </div>
      } @else {
        <div class="documents-list">
          @for(doc of documents; track doc.id) {
            <div class="document-item" style="display: flex; align-items: center; justify-content: space-between; padding: 16px; border: 1px solid #e0e0e0; border-radius: 8px; margin-bottom: 12px; transition: background 0.2s;">
              <div class="doc-info" style="display: flex; align-items: center; gap: 16px;">
                <div class="doc-icon" style="background: #e3f2fd; color: #1976d2;width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center; border-radius: 50%;">
                  <mat-icon>insert_drive_file</mat-icon>
                </div>
                <div>
                  <div class="doc-title" style="font-weight: 600; font-size: 16px;">
                    {{ doc.content?.[0]?.attachment?.title || 'Unnamed Document' }}
                  </div>
                  <div class="doc-meta" style="font-size: 13px; color: #666; display: flex; gap: 16px; margin-top: 4px;">
                    <span>{{ (doc.content?.[0]?.attachment?.creation | date) || 'Unknown Date' }}</span>
                    <span>{{ doc.content?.[0]?.attachment?.contentType || 'Unknown Type' }}</span>
                    <span>{{ (doc.content?.[0]?.attachment?.size | bytetounit) || '' }}</span>
                  </div>
                </div>
              </div>
              <div class="doc-actions" style="display: flex; gap: 8px;">
                <button mat-icon-button color="primary" (click)="downloadDocument(doc)" matTooltip="Download / View">
                  <mat-icon>download</mat-icon>
                </button>
                @if(isPractitioner) {
                  <button mat-icon-button color="warn" (click)="deleteDocument(doc)" matTooltip="Delete Document">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    }
  </mat-card-content>
</mat-card>
